import { Link } from "react-router-dom";

const COLUMNS = [
    {
        title: "Explore",
        links: [
            { label: "How It Works", href: "#how-it-works" },
            { label: "Automations", href: "#automations" },
            { label: "Industries", href: "#industries" },
        ],
    },
    {
        title: "Company",
        links: [
            { label: "Pricing", href: "#pricing" },
            { label: "FAQ", href: "#faq" },
            { label: "Blog", href: "/blog", route: true },
            { label: "Start a Chat Interview", href: "#book" },
        ],
    },
    {
        title: "Services",
        links: [
            { label: "AI Employee", href: "/ai-employee", route: true },
            { label: "Business Automation", href: "/business-automation", route: true },
            { label: "Lead Follow-Up", href: "/lead-follow-up", route: true },
            { label: "Appointment Automation", href: "/appointment-automation", route: true },
            { label: "CRM Automation", href: "/crm-automation", route: true },
            { label: "AI Receptionist", href: "/ai-receptionist", route: true },
            { label: "Service Businesses", href: "/service-business-automation", route: true },
        ],
    },
    {
        title: "Legal",
        links: [
            { label: "Privacy Policy", href: "/privacy-policy", route: true },
            { label: "Terms & Conditions", href: "/terms-and-conditions", route: true },
        ],
    },
];

export default function Footer() {
    return (
        <footer className="border-t border-white/5 py-14" data-testid="footer">
            <div className="container-x flex flex-col md:flex-row justify-between gap-10">
                <div className="max-w-xs">
                    <Link to="/" className="flex items-center gap-2.5">
                        <span className="w-8 h-8 rounded-xl bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center ff-display font-black text-sm text-white">
                            F
                        </span>
                        <span className="ff-display font-bold text-lg text-white tracking-tight">Flowtech</span>
                    </Link>
                    <p className="mt-4 text-sm text-slate-500 leading-relaxed">
                        Your AI employee that works 24/7 — answering leads, booking appointments, and growing your business while you sleep.
                    </p>
                    <div className="mt-5 flex items-center gap-3">
                        <span className="inline-flex items-center gap-1.5 ff-mono text-[9px] uppercase tracking-[0.15em] text-emerald-300 bg-emerald-400/10 border border-emerald-400/20 rounded-full px-2.5 py-1">
                            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                            All Systems Operational
                        </span>
                        <a
                            href="https://www.facebook.com/flowtechsolutionsph"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Flowtech on Facebook"
                            data-testid="footer-facebook-link"
                            className="w-8 h-8 rounded-full border border-white/10 bg-white/5 flex items-center justify-center text-slate-400 hover:text-cyan-300 hover:border-cyan-400/40 transition-[color,border-color] duration-300"
                        >
                            <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current" aria-hidden="true">
                                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                            </svg>
                        </a>
                    </div>
                </div>
                <div className="flex gap-16">
                    {COLUMNS.map((c) => (
                        <div key={c.title}>
                            <p className="ff-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-4">{c.title}</p>
                            <ul className="space-y-3">
                                {c.links.map((l) => (
                                    <li key={l.label}>
                                        {l.route ? (
                                            <Link
                                                to={l.href}
                                                data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                                className="text-sm text-slate-400 hover:text-cyan-300 transition-colors duration-300"
                                            >
                                                {l.label}
                                            </Link>
                                        ) : (
                                            <a href={l.href} className="text-sm text-slate-400 hover:text-cyan-300 transition-colors duration-300">
                                                {l.label}
                                            </a>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
            <div className="container-x mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3">
                <p className="text-xs text-slate-600">© {new Date().getFullYear()} Flowtech. All rights reserved.</p>
                <div className="flex items-center gap-5">
                    <Link to="/privacy-policy" className="text-xs text-slate-600 hover:text-cyan-300 transition-colors duration-300" data-testid="footer-privacy-link">
                        Privacy Policy
                    </Link>
                    <Link to="/terms-and-conditions" className="text-xs text-slate-600 hover:text-cyan-300 transition-colors duration-300" data-testid="footer-terms-link">
                        Terms & Conditions
                    </Link>
                </div>
            </div>
        </footer>
    );
}
